import { useState } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { useAuth } from "@/lib/auth";

export default function AdminLogin() {
  const { user, checking, login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (checking) return <div className="min-h-[60vh]" />;
  if (user) return <Navigate to={loc.state?.from || "/admin"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Signed in.");
      nav(loc.state?.from || "/admin", { replace: true });
    } catch (err) {
      toast.error(err.message || "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="min-h-[100svh] pt-36 pb-24 px-6 lg:px-12 flex items-center"
      data-testid="admin-login-page"
    >
      <div className="mx-auto max-w-md w-full">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div className="text-[10px] uppercase tracking-[0.3em] text-brass-500 mb-4">
            Restricted · Admin
          </div>
          <h1
            className="tracking-[-0.02em] text-navy-600 leading-[0.95] text-[clamp(2.5rem,5vw,4.5rem)]"
            style={{ fontFamily: "'Cormorant Garamond', 'Playfair Display', serif", fontWeight: 500 }}
          >
            Sign in.
          </h1>
          <p className="mt-4 text-navy-600/70 text-sm">
            Access is limited to Dr. Matai&apos;s account.
          </p>

          <form onSubmit={submit} className="mt-10 space-y-8" data-testid="admin-login-form">
            <div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-navy-600/60 mb-3">
                01 · Email
              </div>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="luxe-input w-full py-3 text-navy-600 placeholder:text-navy-600/40"
                data-testid="admin-email-input"
              />
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-navy-600/60 mb-3">
                02 · Password
              </div>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="luxe-input w-full py-3 text-navy-600 placeholder:text-navy-600/40"
                data-testid="admin-password-input"
              />
            </div>
            <button
              type="submit"
              disabled={busy}
              className="mt-6 inline-flex items-center gap-3 bg-navy-600 text-beige-100 px-7 py-4 text-[11px] uppercase tracking-[0.28em] hover:bg-navy-700 transition-colors disabled:opacity-60"
              data-testid="admin-login-submit"
            >
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
}
